import { fasStar } from 'shared/@generated/icons/fasStar';
import { Text } from 'shared/components/text';
import { View } from 'react-native';
import { Image } from 'shared/components/image';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/link';
import { Review } from 'shared/library/reviews';
import { Icon } from 'shared/components/icon';
import { clsx } from 'clsx';
import { useRoute } from 'shared/library/routes/route';

export const ReviewCard = ({ review }: { review: Review }) => {
  const { t } = useTranslation('components');
  const route = useRoute();

  return (
    <View className={'gap-6 p-6 md:flex-row md:items-start md:gap-12'}>
      <Image
        src={review.image ?? ''}
        alt={review.name}
        containerClassName={'md:aspect-4/3 mx-auto aspect-video w-full md:w-1/3'}
        imageClassName={'rounded object-cover md:rounded-lg'}
        sizeType={'card'}
      />

      <View className={'flex-1'}>
        <Text className={'absolute -left-6 -top-6 text-6xl font-bold text-stone-200'}>”</Text>

        <Text className={'text-stone-600 md:text-lg'}>{review.body}</Text>

        <Text className={'text-brand-brown-dark mt-3 font-bold'}>{review.name}</Text>

        {review.role === 'seller' ? (
          <Link
            textClassName={'text-brand-brown-dark/70 text-sm'}
            href={route('breeders.show', { breeder: review.identifier })}
          >
            {t('review_card.view_breeder_profile')}
          </Link>
        ) : (
          <View className={'flex-row items-center gap-1.5'}>
            <View className={'bg-brand-green flex-row items-center gap-0.5 rounded px-1.5 py-1'}>
              <Icon icon={fasStar} className={'size-2.5 text-white'} />
              <Icon icon={fasStar} className={'size-2.5 text-white'} />
              <Icon icon={fasStar} className={'size-2.5 text-white'} />
              <Icon icon={fasStar} className={'size-2.5 text-white'} />
              <Icon
                icon={fasStar}
                className={clsx('size-2.5', {
                  'text-white': review.rating === 5,
                  'text-white/50': review.rating < 5,
                })}
              />
            </View>

            <Text className={'text-brand-brown-dark/70 text-sm'}>{t('review_card.buyer')}</Text>
          </View>
        )}
      </View>
    </View>
  );
};
